import { MediaPacket, } from '@streamr/tv-engine/~/proto';
import { EventEmitter } from 'eventemitter3';
export class MediaPacketDefragmenter extends EventEmitter {
    mediaPacketFragmentMap = new Map();
    feedMediaPacketFragment(mediaPacketFragment) {
        if (mediaPacketFragment.numberOfFragments === 1) {
            const mediaPacket = MediaPacket.fromBinary(mediaPacketFragment.data);
            const mediaPacketWithUserId = {
                ...mediaPacket,
                userId: mediaPacketFragment.userId,
                messageChainId: mediaPacketFragment.messageChainId,
            };
            this.emit('mediaPacket', mediaPacketWithUserId);
        }
        else {
            this.addMediaPacketFragment(mediaPacketFragment);
            this.tryDefragment();
        }
    }
    createCompositeKey(fragment) {
        return `${fragment.userId}:${fragment.messageChainId}:${fragment.mediaStreamId}:${fragment.packetNumber.toString()}`;
    }
    addMediaPacketFragment(mediaPacketFragment) {
        const compositeKey = this.createCompositeKey(mediaPacketFragment);
        const fragmentNumber = mediaPacketFragment.fragmentNumber;
        const fragments = this.mediaPacketFragmentMap.get(compositeKey) || new Map();
        fragments.set(fragmentNumber, mediaPacketFragment);
        this.mediaPacketFragmentMap.set(compositeKey, fragments);
    }
    tryDefragment() {
        if (this.mediaPacketFragmentMap.size === 0) {
            return;
        }
        // Iterate through all composite keys (userId:mediaStreamId:packetNumber)
        for (const [compositeKey, fragments] of this.mediaPacketFragmentMap) {
            const firstFragment = fragments.values().next().value;
            if (!firstFragment) {
                continue;
            }
            const expectedNumberOfFragments = firstFragment.numberOfFragments;
            // Check if we have all fragments for this packet
            if (fragments.size !== expectedNumberOfFragments) {
                continue;
            }
            // Combine fragments in order
            const orderedFragments = Array.from(fragments.values()).sort((a, b) => a.fragmentNumber - b.fragmentNumber);
            let dataSize = 0;
            for (const fragment of orderedFragments) {
                dataSize += fragment.data.length;
            }
            const orderedData = new Uint8Array(dataSize);
            let offset = 0;
            for (const fragment of orderedFragments) {
                orderedData.set(fragment.data, offset);
                offset += fragment.data.length;
            }
            // Parse and emit the complete packet with userId and messageChainId
            const mediaPacket = MediaPacket.fromBinary(orderedData);
            const mediaPacketWithUserId = {
                ...mediaPacket,
                userId: firstFragment.userId,
                messageChainId: firstFragment.messageChainId,
            };
            this.emit('mediaPacket', mediaPacketWithUserId);
            // Remove the defragmented packet from the map
            this.mediaPacketFragmentMap.delete(compositeKey);
        }
    }
    /**
     * Remove all pending fragments for a specific user session.
     * Useful for cleanup when a user disconnects.
     */
    removeFragmentsOfUserSession(userId, messageChainId) {
        const keysToRemove = [];
        // Find all composite keys that belong to this user session
        // Composite key format: "userId:messageChainId:mediaStreamId:packetNumber"
        const sessionPrefix = `${userId}:${messageChainId}:`;
        for (const compositeKey of this.mediaPacketFragmentMap.keys()) {
            if (compositeKey.startsWith(sessionPrefix)) {
                keysToRemove.push(compositeKey);
            }
        }
        // Remove all fragments for this user session
        for (const key of keysToRemove) {
            this.mediaPacketFragmentMap.delete(key);
        }
        if (keysToRemove.length > 0) {
            console.log(`Removed ${keysToRemove.length} incomplete packet(s) for user ${userId} session ${messageChainId}`);
        }
    }
}
